import request from '@/utils/request'
import qs from 'qs'
import { getToken } from '@/utils/auth'

// 登录
export function login(data) {
  return request({
    // url: '/vue-element-admin/user/login',
    url: '/hub/user-auth/login',
    method: 'post',
    data
    // data: qs.stringify(data),
    // headers: { 'content-type': 'application/x-www-form-urlencoded' },
  })
}
// 获取用户信息
export function getInfo(data) {
  return request({
    url: '/hub/user-auth/getLoginInfo',
    method: 'post',
    data
  })
}
// 左侧列表
export function leftList(data) {
  return request({
    url: '/admin/menu/getUserMenu',
    method: 'post',
    data
    // headers:{
    //   'Authorization': 'Bearer' +  getToken()
    // }
  })
}
// 获取系统配置
export function getSystem(data) {
  return request({
    url: '/admin/sysconfig/page',
    method: 'post',
    data
  })
}
export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}
